import React from 'react'
import Contact from '../../components/contact.js';

export default ({location}) => <Contact initialState={location.state}/>